var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"sliderOverlay",staticClass:"slideOverlay",class:{shown: _vm.$store.state.mobileMenuShown},on:{"click":function($event){_vm.$store.state.mobileMenuShown = false}}})}
var staticRenderFns = []

export { render, staticRenderFns }